import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { ToastModule } from '@libs/src/toast/toast.module';
import { VisibleGroupsModule } from '@main-client/src/app/core/visible-groups.module';
import { GroupCustomSegmentSelectorModule } from '@main-client/src/app/group-segment-selector/group-custom-segment-selector.module';
import { FindPipeModule } from '@main-client/src/app/pipes/find-pipe/find-pipe.module';
import { TranslationLookupModule } from '@main-client/src/app/pipes/translation-lookup/translation-lookup.module';

import { AccountBackend } from '@libs/src/account/account.backend';
import { AccountHubsEditService } from '@main-client/src/app/account/account-hubs-edit.service';
import { GroupMembershipService } from '@main-client/src/app/core/group-membership.service';
import { UserMutationService } from '@main-client/src/app/user/user-mutation.service';

import { ProfileHubItemComponent } from '@main-client/src/app/profile/profile-hub-item/profile-hub-item.component';

@NgModule({
  imports: [
    CommonModule,
    FindPipeModule,
    FlexLayoutModule,
    FormsModule,
    GroupCustomSegmentSelectorModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSlideToggleModule,
    NzIconModule,
    NzSpinModule,
    NzToolTipModule,
    ReactiveFormsModule,
    RouterModule.forChild([]),
    ToastModule,
    VisibleGroupsModule,
    TranslationLookupModule,
  ],
  declarations: [ProfileHubItemComponent],
  exports: [ProfileHubItemComponent],
  providers: [
    AccountBackend,
    AccountHubsEditService,
    GroupMembershipService,
    UserMutationService,
  ],
})
export class ProfileHubItemModule {}
